module.exports = __webpack_public_path__ + "static/media/toolsCopy.09c74432.svg";